exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "::ng-deep .full-height-panel {\n  height: 100%; }\n  ::ng-deep .full-height-panel section div {\n    height: calc(100% - 50px); }\n\n::ng-deep .node-project, ::ng-deep .node-zone, ::ng-deep .node-feature {\n  height: 25px;\n  vertical-align: middle; }\n\n::ng-deep .node-project {\n  background-color: #fac8e1 !important; }\n\n::ng-deep .node-zone {\n  background-color: #d9c8fa !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/features/components/project-usages/feature-project-usages.component.scss
// module id = ../../../../../src/app/modules/features/components/project-usages/feature-project-usages.component.scss
// module chunks = main